import { render, staticRenderFns } from "./GroupLists.vue?vue&type=template&id=0a2a4cf8&"
import script from "./GroupLists.vue?vue&type=script&lang=js&"
export * from "./GroupLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports